import React from 'react';
import {
  Row,
  Col,
  FormGroup,
  Button,
  Label,
  Input,
  CardBody,
  CardTitle,
  CardText,
  Card
} from 'reactstrap';
import * as acessos from '../../../acessos.const.util';
import './documentos-externos.styles.css';
import * as apiCommon from '../util/api-common.util';
import IntlMessage from "../../../helpers/intlMessage";
import { useIntl } from 'react-intl';

const DocumentosExternosPage = props => {

  const intl = useIntl();

  return (
  <div>
    {props.acessoPermitido(props.usuario, acessos.Adicionar) &&
      props.acessoPermitido(props.usuario, acessos.DocExterno) && (
        <Row>
          <Col>
            <FormGroup>
              <Label><IntlMessage id = "dashboards.examDetail.documentDescription"/></Label>
              <Input
                value={props.nomeDocumento}
                onChange={props.atualizarNomeDocumento}
                disabled={props.exameFinalizado}
                maxLength={70}
              />
              <Label><b>{apiCommon.textLengthMessage(props.nomeDocumento, 70, intl)}</b></Label>
            </FormGroup>
          </Col>
          <Col sm='auto'>
            <FormGroup>
              <Button
                color='primary'
                className='btn-add-docexterno'
                disabled={props.exameFinalizado}
                onClick={props.registrarRecebimentoDocExterno}
              >
                <span><IntlMessage id = "dashboards.examDetail.receiveDocument"/></span>
              </Button>
            </FormGroup>
          </Col>
        </Row>
      )}
    <div
      style={{
        height: `${props.altura - 123}px`,
        width: '100%',
        overflowY: 'scroll',
        overflowX: 'hidden'
      }}
    >
      {props.listagemDocumentosExternos.map(doc => {
        return (
          <Row key={doc.id}>
            <Col>
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      <CardTitle>
                        {doc.nomeDocumento}
                        {doc.entregue}
                        <IntlMessage id = "dashboards.examDetail.deliveredIn"/>
                        {`${doc.dataSaidaDocumento}`}
                      </CardTitle>
                      <CardText>
                        <IntlMessage id = "dashboards.examDetail.receivedIn"/> {`${doc.dataEntradaDocumento}`}
                      </CardText>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        );
      })}
    </div>
  </div>
);
    }

export default DocumentosExternosPage;



// WEBPACK FOOTER //
// ./src/app/common/documentosExternos/documentos-externos.page.js